var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dings)?_c('p',[_vm._v(_vm._s(_vm.dings.email)+" "+_vm._s(_vm.count))]):_vm._e(),_c('p',[_c('button',{on:{"click":_vm.increment}},[_vm._v("+")]),_c('button',{on:{"click":_vm.decrement}},[_vm._v("-")])])])}
var staticRenderFns = []

export { render, staticRenderFns }